import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { Button } from 'src/@/components/ui/button';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { Label } from 'src/@/components/ui/label';
import { Switch } from 'src/@/components/ui/switch';
import { Separator } from 'src/@/components/ui/separator';
import Iconify from 'src/components/Iconify';
import v2_actionClienteConfigCheck from 'src/actions/v2/cliente/v2_actionCheck';
import v2_actionEditarCliente from 'src/actions/v2/cliente/v2_actionEditarCliente';

// material
import useAuth from 'src/hooks/useAuth';

export default function Autocomplete() {
    const { logout, user, cliente } = useAuth();
    const navigate = useNavigate();
    const [prompt, setPrompt] = useState('');
    const [isAtivo, setIsAtivo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSalvar = async () => {
        try {
            setIsLoading(true);
            let data = {
                scope: {
                    "config.modules.autocomplete.status": isAtivo,
                    "config.modules.autocomplete.prompt": prompt
                }
            };

            console.log('Dados a serem enviados:', data);

            const response = await v2_actionEditarCliente(cliente._id, data);

            if (response.data.error === false) {
                const { autocomplete } = response.data.data.scope["config.modules"];
                setIsAtivo(autocomplete.status);
                setPrompt(autocomplete.prompt);
            }
        } catch (error) {
            console.error('Erro ao salvar configurações:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await v2_actionClienteConfigCheck(cliente._id, 'aiCheck,configModules');
                if (response.data.error === false) {
                    const { autocomplete } = response.data.data.configModules;
                    console.log('Dados recebidos do servidor:', autocomplete);
                    setIsAtivo(autocomplete.status);
                    setPrompt(autocomplete.prompt);
                }
            } catch (error) {
                console.error('Erro ao buscar configurações:', error);
            }
        };

        if (cliente?._id) {
            fetchConfig();
        }
    }, [cliente?._id]);

    return (
        <div className="container mx-auto p-4">
            <div className="flex flex-row items-center justify-between mb-6">
                <div className="flex flex-row items-center gap-2">
                    <Button
                        size="icon"
                        variant="outline"
                        onClick={() => navigate('/dashboard/configuracoes/modulos')}
                    >
                        <Iconify icon="majesticons:arrow-left" color="black" />
                    </Button>
                    <h2 className="text-2xl font-semibold">Autocompletar</h2>
                </div>
                <Button
                    variant="default"
                    size="sm"
                    onClick={handleSalvar}
                    disabled={isLoading || !prompt}
                >
                    {isLoading ? 'Salvando...' : 'Salvar'}
                </Button>
            </div>

            <Separator className="mb-6" />

            <div className="grid grid-cols-1 gap-6">
                <div className="flex flex-row gap-4 items-center">
                    <Label htmlFor="status" className="min-w-[150px] text-right">Status</Label>
                    <div className="flex flex-row gap-2 items-center">
                        <Switch
                            id="status"
                            checked={isAtivo}
                            onCheckedChange={setIsAtivo}
                        />
                        <p className="text-sm text-muted-foreground">
                            Ative ou desative a análise de atendimento
                        </p>
                    </div>
                </div>

                <div className="flex flex-row gap-4 items-start">
                    <Label htmlFor="prompt" className="min-w-[150px] text-right pt-2">Prompt</Label>
                    <div className="flex-1">
                        <Textarea
                            id="prompt"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            placeholder="Digite o prompt que será usado para gerar a análise..."
                            className="min-h-[150px]"
                        />
                        <p className="text-sm text-muted-foreground mt-2">
                            O prompt será usado para gerar a análise do atendimento. Seja específico e claro em suas instruções.
                        </p>
                    </div>
                </div>

   
            </div>
        </div>
    );
}
